import { render, staticRenderFns } from "./Congratulation.vue?vue&type=template&id=2dbf3579&scoped=true&"
import script from "./Congratulation.vue?vue&type=script&lang=js&"
export * from "./Congratulation.vue?vue&type=script&lang=js&"
import style0 from "./Congratulation.vue?vue&type=style&index=0&id=2dbf3579&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf3579",
  null
  
)

export default component.exports